<script>
import modalMixin from '@/mixins/modalMixin'
import { mapGetters } from 'vuex'

/**
 * TODO: The clientId should be passed into this component based on the
 * location selected to create the booking
 */
export default {
  name: 'BookingPassedCutOffCard',
  mixins: [modalMixin],
  computed: {
    ...mapGetters({
      getOwner: 'client/owner',
      getSelectedClients: 'client/getSelectedClients', // TODO: Remove
    }),
    owner() {
      return this.getOwner(this.getSelectedClients[0])
    },
    ownerName() {
      return this.owner?.ownerName
    },
    ownerPhone() {
      return this.owner?.ownerPhone
    },
  },
}
</script>

<template>
  <v-card>
    <v-toolbar flat color="warning" dark>
      <v-icon left>mdi-clock-alert</v-icon>
      {{ $t('booking.sameDayCutOffDialogTitle') }}
    </v-toolbar>
    <v-card-text class="mt-4 body-1">
      {{ $t('booking.sameDayCutOffDialogDescPartial1') }}
      <a :tel="ownerPhone"> {{ ownerPhone }}. </a>
      {{ $t('booking.sameDayCutOffDialogDescPartial2') }}
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text @click="close">{{ $t('general.dismiss') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
